<template>
  <section id="Categoria" class="categorias">
   
    <h2 class="titulo">💡 Categorías de Electrónica</h2>

    <div class="grid-categorias">
      <div
        v-for="(categoria, index) in categorias"
        :key="index"
        class="card-categoria"
      >
        <img :src="categoria.icono" :alt="categoria.titulo" class="icono" />
        <h3 class="card-titulo">{{ categoria.titulo }}</h3>
        <p class="card-descripcion">{{ categoria.descripcion }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CategoriasElectronica',
  data() {
    return {
      categorias: [
        {
          titulo: 'Reparación de Equipos',
          icono: require('@/assets/icons/reparacion.png'), 
          descripcion: 'Servicio profesional de reparación y mantenimiento de computadoras, laptops y dispositivos electrónicos.'
        },
        {
          titulo: 'Componentes y Hardware',
          icono: require('@/assets/icons/hardware.png'),
          descripcion: 'Venta y asesoría sobre componentes electrónicos, placas, sensores y periféricos.'
        },
        {
          titulo: 'Automatización y Gadgets',
          icono: require('@/assets/icons/gadgets.png'),
          descripcion: 'Instalación y configuración de sistemas electrónicos inteligentes y gadgets tecnológicos.'
        },
        {
          titulo: 'Soporte Técnico',
          icono: require('@/assets/icons/soporte.png'),
          descripcion: 'Asesoría y asistencia en problemas de software y hardware para empresas y particulares.'
        },
        {
  titulo: 'Soporte Técnico Microsoldadura',
  icono: require('@/assets/icons/Microsoldadura.png'),
  descripcion: 'Asesoría y asistencia en problemas de software y hardware para empresas y particulares, incluyendo servicio de microsoldadura para componentes electrónicos de alta precisión.'
},
{
  titulo: 'Soporte Técnico  Reballing Chips',
  icono: require('@/assets/icons/Reballing.png'),
  descripcion: 'Asesoría y asistencia en problemas de software y hardware para empresas y particulares, incluyendo microsoldadura de precisión y servicio de reballing para restaurar chips BGA y componentes electrónicos críticos.'
},
{
  titulo: 'Mantenimiento Preventivo',
  icono: require('@/assets/icons/maintenance.png'),
  descripcion: 'Servicio especializado para prolongar la vida útil de equipos mediante limpieza interna, cambio de pasta térmica, revisión de fuentes, ventilación y chequeo general de hardware.'
},
{
  titulo: 'Soldadura Electrónica',
  icono: require('@/assets/icons/soldadura.png'),
  descripcion: 'Servicio especializado en soldadura de componentes electrónicos: reparación de pistas, conectores, capacitores, resistencias y módulos dañados con precisión y herramientas profesionales.'
}





      ]
    }
  }
}
</script>

<style scoped>
.categorias {
  background: url('@/assets/Img/Banners/electronica-fondo.jpg') no-repeat center center;
  background-size: cover;
  padding: 3rem 2rem;
  color: #fff;
  text-align: center;
}


.titulo {
  font-size: 2.5rem;
  margin-bottom: 2rem;
  font-weight: bold;
  color: #ffffff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
  animation: fadeInDown 1s ease-in-out;
}

.grid-categorias {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: auto;
}

.card-categoria {
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  transition: transform 0.4s ease, box-shadow 0.4s ease;
  color: #333;
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0;
  animation: fadeInUp 1s ease forwards;
}

.card-categoria:nth-child(1) { animation-delay: 0.1s; }
.card-categoria:nth-child(2) { animation-delay: 0.2s; }
.card-categoria:nth-child(3) { animation-delay: 0.3s; }
.card-categoria:nth-child(4) { animation-delay: 0.4s; }
.card-categoria:nth-child(5) { animation-delay: 0.5s; }
.card-categoria:nth-child(6) { animation-delay: 0.6s; }
.card-categoria:nth-child(7) { animation-delay: 0.7s; }
.card-categoria:nth-child(8) { animation-delay: 0.8s; }

.card-categoria:hover {
  transform: translateY(-8px) scale(1.05);
  box-shadow: 0 12px 32px rgba(0, 242, 255, 0.4);
}

/* ✅ Efecto zoom al pasar el mouse sobre el icono */
.icono {
  width: 80px;
  height: 80px;
  margin-bottom: 1rem;
  object-fit: contain;
  transition: transform 0.4s ease;
}

.card-categoria:hover .icono {
  transform: scale(1.2) rotate(5deg);
}

.card-titulo {
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-align: center;
}

.card-descripcion {
  font-size: 0.95rem;
  text-align: center;
  line-height: 1.4;
}

/* Animaciones */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
